import React from "react";
import { Link } from "react-router-dom";

export default function HoteleriaCostaAtlanticaPrimario({ bgColor }) {
  return (
    <>
      <section
        id="hoteleria"
        className={`contact-us ptb-100 ${bgColor ? "gray-light-bg" : ""}`}
      >
        <section className="team-member-section ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7 col-md-8">
                <div className="section-heading text-center mb-4">
                  <h2>HOTELERIA EXCLUSIVA</h2>
                  <h3>All inclusive</h3>
                  <p className="lead">
                  Nuestros hoteles exclusivos para turismo estudiantil más exclusivos del mercado.
                  </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/costaAtlantica/CostaAtlantica-hotel-atlantico-suites.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Atlantic Suites</h5>
                    <h6>Playa</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      {/* <li className="list-inline-item">
                        <Link to="https://www.facebook.com/PortofinoRamallo">
                          <span className="ti-facebook"></span>
                        </Link>
                      </li> */}
                      <li className="list-inline-item">
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to="https://www.instagram.com/hotelatlanticosuites?igsh=MWd6d3EwcndxcWJhbw=="
                        >
                          <span className="ti-instagram"></span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/costaAtlantica/CostaAtlantica-GranHotel.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Grand Hotel </h5>
                    <h5 className="mb-0">Santa Teresita</h5>
                    <h6>Playa</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      <li className="list-inline-item">
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to="https://www.facebook.com/GrandHotelSantaTeresita1/?locale=es_LA"
                        >
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link
                          target="_blank"
                          rel="noopener noreferrer"
                          to="https://www.instagram.com/ghsantateresita"
                        >
                          <span className="ti-instagram"></span>
                        </Link>
                      </li>
                    </ul>
                    <a
                      href="https://www.ghsantateresita.com.ar"
                      target="_blank"
                      rel="noreferrer"
                      className="btn app-store-btn"
                    >
                      Ver hotel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
